import type { UkAddressParts } from "@/utils/quoteMapper";

const STORAGE_KEY = "helio_pending_plan";

/** Illustrative unit rate (£/kWh) used to turn a monthly bill into annual kWh. Matches the bill funnel. */
const UNIT_RATE_GBP = 0.27;

export type PendingPlanDraft = {
  address: UkAddressParts;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  annualKwh: number;
  includesEv: boolean;
  includesHeatPump: boolean;
};

export function annualKwhFromMonthlyBill(monthlyBillGbp: number): number {
  const monthly = Number.isFinite(monthlyBillGbp) ? Math.max(0, monthlyBillGbp) : 0;
  return Math.max(500, Math.round((monthly * 12) / UNIT_RATE_GBP));
}

export function savePendingPlanDraft(draft: PendingPlanDraft): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
  } catch {
    // Private mode or quota. The in-memory quote-flow handoff still runs.
  }
}

export function peekPendingPlanDraft(): PendingPlanDraft | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<PendingPlanDraft>;
    if (!parsed.address?.address1?.trim() || !parsed.address.postcode?.trim()) return null;
    return parsed as PendingPlanDraft;
  } catch {
    return null;
  }
}

export function takePendingPlanDraft(): PendingPlanDraft | null {
  const draft = peekPendingPlanDraft();
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  return draft;
}
